import React, { useState } from "react"
import { HeaderWrapper, LogoWrapper } from "./styles"
import Logo from "../../images/Logo.svg"
import { Menu } from "../Menu"
import { Hamburger } from "../Hamburger"
import { MobileMenu } from "../MobileMenu"
export function Header({ page }) {
	const [menuOpen, setMenuOpen] = useState(false)
	return (
		<HeaderWrapper>
			<a href="http://sheroes.com/">
				<LogoWrapper src={Logo} alt="date" />
			</a>
			<Menu />
			<MobileMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
			<Hamburger menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
		</HeaderWrapper>
	)
}
